import { render, staticRenderFns } from "./form-credit-mini.vue?vue&type=template&id=322f3990&"
import script from "./form-credit-mini.vue?vue&type=script&lang=js&"
export * from "./form-credit-mini.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {FormCreditCalculator: require('/var/www/components/form/form-components/form-credit-calculator.vue').default,CheckboxGroup: require('/var/www/components/checkbox/checkbox-group.vue').default,InputsInput: require('/var/www/components/inputs/input.vue').default})
